import {Link} from "react-router-dom";
import {Form, FormFeedback, FormGroup, Label, Input, Button} from "reactstrap";
import Logo from '../../assets/images/BX-LOGO.svg'
import {useContext, useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom'
import AuthContext from "../../context/AuthContext";
import {login} from "../../api/api";
import Loader from "../../components/Loader";


function Login() {
    // const queryClient = useQueryClient()
    // const { status, data:userData } = useAuth()
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const {setUser, setAuthTokens} = useContext(AuthContext)

    const navigate = useNavigate()

    const loginMutation = useMutation({
        mutationFn: login,
        onSuccess: (data, variables) =>{
            // toggle()
            // queryClient.invalidateQueries(['products'])
            setEmail('')
            setPassword('')
            setAuthTokens({
                accessToken: data.tokens.access,
                refreshToken: data.tokens.refresh,
            })
            // setUser(jwt_decode(data.tokens.access))
            setUser(data)
            navigate(data.must_change_password ? "/force-password-change" : "/", {replace: true})
            // tokenRefreshMutation.mutate()
            // const newData = {"results":[{'first_name': 'Vamsi'}]}
            // queryClient.setQueryData(['user'], newData)
            toast.success('Logged In!')
        },
        onError: err => {
            toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        }
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);
        loginMutation.mutate(formData)
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                             alt={Logo}/>
                                        </span>
                                        <p className="text-muted mb-4 mt-3">
                                            Enter your email address and
                                            password to access BlackX Dashboard.
                                        </p>
                                        {/*<p>{isRunning ? 'Running' : 'Not running'}</p>*/}
                                        {/*<span>{days}</span>:<span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>*/}
                                    </div>

                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="email-address">
                                                Email address
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="email"
                                                id="email-address"
                                                value={email}
                                                placeholder="Enter your email"
                                                invalid={
                                                    loginMutation.isError &&
                                                    loginMutation.error.response.data.email
                                                }
                                                onChange={(e) =>
                                                    setEmail(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    loginMutation.isError &&
                                                    loginMutation.error.response.data.email}
                                            </FormFeedback>
                                        </FormGroup>

                                        <FormGroup className="form-group mb-3">
                                            <Label for="password">
                                                Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="password"
                                                id="password"
                                                value={password}
                                                placeholder="Enter your password"
                                                invalid={
                                                    loginMutation.isError &&
                                                    loginMutation.error.response.data.password
                                                }
                                                onChange={(e) =>
                                                    setPassword(e.target.value)
                                                }
                                            />

                                            <FormFeedback invalid>
                                                {
                                                    loginMutation.isError &&
                                                    loginMutation.error.response.data.password}
                                            </FormFeedback>
                                        </FormGroup>


                                        <FormGroup>
                                            <Button type="submit"
                                                    className="btn bx-btn-primary btn-block waves-effect waves-light mt-2"
                                                // disabled={!stockTransactionName && !stock && !stockTransactionType &&
                                                // !dateCreated}
                                                disabled={loginMutation.isLoading}
                                            >
                                               {loginMutation.isLoading? <><Loader size={'small'}/>Logging In...</>: `Log In`} 
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p>
                                        {" "}
                                        {/* <a href='pages-recoverpw.html' className='text-muted ml-1'> */}
                                        Forgot your password? Click{" "}
                                        <Link to="/reset-password">here</Link>{" "}
                                        to reset
                                        {/* </a> */}
                                    </p>
                                    <p className="text-muted">
                                        Don't have an account?
                                        <Link
                                            to="/register"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                           Register
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
